export const AIRCRAFT_TYPES = [
  {
    label: "Avion",
    options: [
      { code: "SEP", label: "Monomotor cu piston" },
      { code: "MEP", label: "Bimotor cu piston" },
      { code: "TURBOPROP", label: "Turbopropulsor" },
      { code: "JET", label: "Business Jet" },
      { code: "COMMERCIAL", label: "Avion comercial" },
      { code: "AMPHIBIAN", label: "Avion amfibiu / Hidroavion" },
    ]
  },
  {
    label: "Aeronavă Ușoară și Sportivă",
    options: [
      { code: "ULM", label: "Avion ultraușor" },
      { code: "EXPERIMENTAL", label: "Avion experimental" },
    ]
  },
  {
    label: "Aeronavă cu Rotor",
    options: [
      { code: "HELI_PISTON", label: "Elicopter cu piston" },
      { code: "HELI_TURBINE", label: "Elicopter cu turbină" },
      { code: "GYRO", label: "Girocopter" },
      { code: "TILTROTOR", label: "Tiltrotor" },
    ]
  },
  {
    label: "Aeronavă cu Aripă Flexibilă",
    options: [
      { code: "PARAGLIDER", label: "Parapantă" },
      { code: "PARAMOTOR", label: "Motoparapantă" },
      { code: "PARATRIKE", label: "Paratrike" },
      { code: "HANG_GLIDER", label: "Deltaplan" },
      { code: "TRIKE", label: "Motodeltaplan" },
    ]
  },
  {
    label: "Planor",
    options: [
      { code: "GLIDER", label: "Planor" },
      { code: "MOTOR_GLIDER", label: "Motoplanor" },
    ]
  },
  {
    label: "Mai ușoară decât aerul",
    options: [
      { code: "HOT_AIR_BALLOON", label: "Balon cu aer cald" },
      { code: "GAS_BALLOON", label: "Balon cu gaz" },
      { code: "AIRSHIP", label: "Dirijabil" },
    ]
  },
  {
    label: "Speciale și Drone",
    options: [
      { code: "UAV", label: "Dronă comercială (UAV)" },
      { code: "EVTOL", label: "eVTOL" },
    ]
  }
];

export const AIRCRAFT_STATES = [
    { code: "NEW", label: "Nou" },
    { code: "SH", label: "Second-Hand" },
    { code: "REFURBISHED", label: "Recondiționat" },
    { code: "FOR_PARTS", label: "Pentru piese" },
    { code: "DAMAGED", label: "Avariat" }
]

export const AVIONICS = [
  "Glass Cockpit (G1000/G3X/Dynon)",
  "EFIS (Electronic Flight Instrument System)",
  "PFD (Primary Flight Display)",
  "MFD (Multi-Function Display)",
  "HUD (Head-Up Display)",
  "SVS (Synthetic Vision System)",
  "GPS / Moving Map",
  "VOR / ILS / DME",
  "ADF (Automatic Direction Finder)",
  "Marker Beacon",
  "IRS / IRU (Inertial Reference Unit)",
  "FMS (Flight Management System)",
  "RNAV Capability",
  "Radio VHF (8.33 kHz)",
  "Radio HF (Long Range)",
  "Audio Panel / Intercom",
  "CPDLC (Controller-Pilot Data Link)",
  "SATCOM",
  "Transponder Mode S / ADS-B Out",
  "ADS-B In (Traffic & Weather)",
  "TCAS / TAS (Traffic Collision Avoidance)",
  "TAWS / GPWS (Terrain Awareness)",
  "Radio Altimetru (RADALT)",
  "Stormscope / Radar Meteo",
  "ELT (Emergency Locator Transmitter)",
  "Angle of Attack (AoA) Indicator",
  "Autopilot (2-Axis/3-Axis)",
  "Autothrottle",
  "Yaw Damper",
  "Flight Director (FD)",
  "EMS (Engine Monitoring System)",
  "Fuel Flow / Totalizer",
  "EGT / CHT Monitor",
  "OAT Indicator (Outside Air Temperature)",
  "Chronometer / Flight Timer",
  "Altimetru (ALT)",
  "Vitezometru (ASI)",
  "Variometru (VSI)",
  "Orizont Artificial (AI)",
  "Indicator Viraj și Glisadă (Turn & Bank)",
  "Giroscopic Direcțional (HI)",
  "Busolă Magnetică",
  "CVR (Cockpit Voice Recorder)",
  "FDR (Flight Data Recorder)",
  "EFB (Electronic Flight Bag) Support",
  "Altele"
];

export const EQUIPMENT = [
         "Tren retractabil",
         "Tren fix",
         "Tren de aterizare taildragger (triciclu inversat)",
         "Frâne hidraulice",
         "Frâne pe disc (Dual Braking)",
         "Sistem de frânare la parcare (Parking Brake)",
         "Fairings (Carenaje roți)",
         "Flotoare (Floats) / Schiuri",
         "Flaps-uri electrice",
         "Flaps-uri manuale",
         "Aerofâne / Spoilers",
         "Vortex Generators",
         "Trim electric (Pitch/Roll/Yaw)",
         "Trim manual",
         "Elice cu pas variabil (Constant Speed)",
         "Elice cu pas fix",
         "Elice pliabilă (pentru planoare)",
         "Reverse Thrust",
         "Sistem parașută balistică (BRS/CAPS)",
         "De-icing (Pneumatic/TKS/Electric)",
         "Pitot Heat",
         "Sistem detectare CO (Monoxid de Carbon)",
         "Centuri de siguranță în 4/5 puncte (Airbag belts)",
         "Extincteur dedicat (Halon/E-Liquid)",
         "Lumini LED (Aterizare/Taxi)",
         "Strobes (Lumini de tip bliț)",
         "NAV Lights (Lumini de navigație)",
         "Lumini ambientale cockpit (Dimmable)",
         "Parbriz tratat anti-UV / Încălzit",
         "Interior piele / Alcantara",
         "Scaune reglabile pe înălțime/adâncime",
         "Încălzire cabină / Ventilație",
         "Aer condiționat",
         "Izolație fonică premium",
         "Porturi USB (Fast Charge) / Priză 12V",
         "Cârlig remorcare (Tow Hook)",
         "Căști ANR (Active Noise Reduction)",
         "Rezervoare suplimentare (Long Range)",
         "Oxygen System (Built-in)",
         "Pompă de combustibil auxiliară",
         "Alternator de rezervă (Backup Alternator)",
         "Huse protecție (Cowl/Canopy/Wings)",
         "Vopsea custom / Livery special",
         "Scăriță acces (Steps)",
         "Sistem de ancorare (Tie-down kit)",
         "Altele"
];

export const AIRCRAFT_ORIGIN_COUNTRIES = [
  { code: "ZA", label: "Africa de Sud" },
  { code: "AR", label: "Argentina" },
  { code: "AU", label: "Australia" },
  { code: "AT", label: "Austria" },
  { code: "BE", label: "Belgia" },
  { code: "BR", label: "Brazilia" },
  { code: "BG", label: "Bulgaria" },
  { code: "CA", label: "Canada" },
  { code: "CZ", label: "Cehia" },
  { code: "CN", label: "China" },
  { code: "KR", label: "Coreea de Sud" },
  { code: "CH", label: "Elveția" },
  { code: "FI", label: "Finlanda" },
  { code: "FR", label: "Franța" },
  { code: "DE", label: "Germania" },
  { code: "GR", label: "Grecia" },
  { code: "IN", label: "India" },
  { code: "IL", label: "Israel" },
  { code: "IT", label: "Italia" },
  { code: "JP", label: "Japonia" },
  { code: "LV", label: "Letonia" },
  { code: "LT", label: "Lituania" },
  { code: "GB", label: "Marea Britanie" },
  { code: "MX", label: "Mexic" },
  { code: "NZ", label: "Noua Zeelandă" },
  { code: "NL", label: "Olanda" },
  { code: "PL", label: "Polonia" },
  { code: "PT", label: "Portugalia" },
  { code: "RO", label: "România" },
  { code: "RU", label: "Rusia" },
  { code: "RS", label: "Serbia" },
  { code: "SK", label: "Slovacia" },
  { code: "SI", label: "Slovenia" },
  { code: "ES", label: "Spania" },
  { code: "US", label: "Statele Unite ale Americii" },
  { code: "SE", label: "Suedia" },
  { code: "TR", label: "Turcia" },
  { code: "UA", label: "Ucraina" },
  { code: "HU", label: "Ungaria" },
  { code: "OTHER", label: "Altă țară / Nespecificat" }
];

export const AIRCRAFT_REGISTRATION_COUNTRIES = [
  { code: "RO", label: "România (YR)", prefix: ["YR"] },
  { code: "AF", label: "Afganistan (YA)", prefix: ["YA"] },
  { code: "ZA", label: "Africa de Sud (ZS, ZT, ZU)", prefix: ["ZS", "ZT", "ZU"] },
  { code: "AL", label: "Albania (ZA)", prefix: ["ZA"] },
  { code: "DZ", label: "Algeria (7T)", prefix: ["7T"] },
  { code: "AD", label: "Andorra (C3)", prefix: ["C3"] },
  { code: "AO", label: "Angola (D2)", prefix: ["D2"] },
  { code: "AI", label: "Anguilla (VP-A)", prefix: ["VP-A"] },
  { code: "AN", label: "Antigua și Barbuda (V2)", prefix: ["V2"] },
  { code: "SA", label: "Arabia Saudită (HZ)", prefix: ["HZ"] },
  { code: "AR", label: "Argentina (LV, LQ)", prefix: ["LV", "LQ"] },
  { code: "AM", label: "Armenia (EK)", prefix: ["EK"] },
  { code: "AW", label: "Aruba (P4)", prefix: ["P4"] },
  { code: "AU", label: "Australia (VH)", prefix: ["VH"] },
  { code: "AT", label: "Austria (OE)", prefix: ["OE"] },
  { code: "AZ", label: "Azerbaidjan (4K)", prefix: ["4K"] },
  { code: "BS", label: "Bahamas (C6)", prefix: ["C6"] },
  { code: "BH", label: "Bahrain (A9C)", prefix: ["A9C"] },
  { code: "BD", label: "Bangladesh (S2)", prefix: ["S2"] },
  { code: "BB", label: "Barbados (8P)", prefix: ["8P"] },
  { code: "BE", label: "Belgia (OO)", prefix: ["OO"] },
  { code: "BZ", label: "Belize (V3)", prefix: ["V3"] },
  { code: "BJ", label: "Benin (TY)", prefix: ["TY"] },
  { code: "BM", label: "Bermuda (VP-B, VQ-B)", prefix: ["VP-B", "VQ-B"] },
  { code: "BT", label: "Bhutan (A5)", prefix: ["A5"] },
  { code: "BY", label: "Belarus (EW)", prefix: ["EW"] },
  { code: "BO", label: "Bolivia (CP)", prefix: ["CP"] },
  { code: "BA", label: "Bosnia și Herțegovina (E7)", prefix: ["E7"] },
  { code: "BW", label: "Botswana (A2)", prefix: ["A2"] },
  { code: "BR", label: "Brazilia (PP, PR, PT, PU, PS)", prefix: ["PP", "PR", "PT", "PU", "PS"] },
  { code: "BN", label: "Brunei (V8)", prefix: ["V8"] },
  { code: "BG", label: "Bulgaria (LZ)", prefix: ["LZ"] },
  { code: "BF", label: "Burkina Faso (XT)", prefix: ["XT"] },
  { code: "BI", label: "Burundi (9U)", prefix: ["9U"] },
  { code: "KH", label: "Cambodgia (XU)", prefix: ["XU"] },
  { code: "CM", label: "Camerun (TJ)", prefix: ["TJ"] },
  { code: "CA", label: "Canada (C, CF)", prefix: ["C", "CF"] },
  { code: "CV", label: "Capul Verde (D4)", prefix: ["D4"] },
  { code: "CZ", label: "Cehia (OK)", prefix: ["OK"] },
  { code: "CL", label: "Chile (CC)", prefix: ["CC"] },
  { code: "CN", label: "China (B)", prefix: ["B"] },
  { code: "CY", label: "Cipru (5B)", prefix: ["5B"] },
  { code: "CO", label: "Columbia (HK)", prefix: ["HK"] },
  { code: "KM", label: "Comore (D6)", prefix: ["D6"] },
  { code: "CG", label: "Congo (TN)", prefix: ["TN"] },
  { code: "CD", label: "Congo, R.D. (9Q)", prefix: ["9Q"] },
  { code: "KP", label: "Coreea de Nord (P)", prefix: ["P"] },
  { code: "KR", label: "Coreea de Sud (HL)", prefix: ["HL"] },
  { code: "CI", label: "Coasta de Fildeș (TU)", prefix: ["TU"] },
  { code: "CR", label: "Costa Rica (TI)", prefix: ["TI"] },
  { code: "HR", label: "Croația (9A)", prefix: ["9A"] },
  { code: "CU", label: "Cuba (CU)", prefix: ["CU"] },
  { code: "DK", label: "Danemarca (OY)", prefix: ["OY"] },
  { code: "DJ", label: "Djibouti (J2)", prefix: ["J2"] },
  { code: "DM", label: "Dominica (J7)", prefix: ["J7"] },
  { code: "EC", label: "Ecuador (HC)", prefix: ["HC"] },
  { code: "EG", label: "Egipt (SU)", prefix: ["SU"] },
  { code: "SV", label: "El Salvador (YS)", prefix: ["YS"] },
  { code: "CH", label: "Elveția (HB)", prefix: ["HB"] },
  { code: "AE", label: "Emiratele Arabe Unite (A6)", prefix: ["A6"] },
  { code: "ER", label: "Eritreea (E3)", prefix: ["E3"] },
  { code: "EE", label: "Estonia (ES)", prefix: ["ES"] },
  { code: "ET", label: "Etiopia (ET)", prefix: ["ET"] },
  { code: "FJ", label: "Fiji (DQ)", prefix: ["DQ"] },
  { code: "PH", label: "Filipine (RP)", prefix: ["RP"] },
  { code: "FI", label: "Finlanda (OH)", prefix: ["OH"] },
  { code: "FR", label: "Franța (F)", prefix: ["F"] },
  { code: "GA", label: "Gabon (TR)", prefix: ["TR"] },
  { code: "GM", label: "Gambia (C5)", prefix: ["C5"] },
  { code: "GE", label: "Georgia (4L)", prefix: ["4L"] },
  { code: "DE", label: "Germania (D)", prefix: ["D"] },
  { code: "GH", label: "Ghana (9G)", prefix: ["9G"] },
  { code: "GI", label: "Gibraltar (VP-G)", prefix: ["VP-G"] },
  { code: "GD", label: "Grenada (J3)", prefix: ["J3"] },
  { code: "GR", label: "Grecia (SX)", prefix: ["SX"] },
  { code: "GL", label: "Groenlanda (OY)", prefix: ["OY"] },
  { code: "GU", label: "Guam (N)", prefix: ["N"] },
  { code: "GT", label: "Guatemala (TG)", prefix: ["TG"] },
  { code: "GN", label: "Guineea (3X)", prefix: ["3X"] },
  { code: "GY", label: "Guyana (8R)", prefix: ["8R"] },
  { code: "HT", label: "Haiti (HH)", prefix: ["HH"] },
  { code: "HN", label: "Honduras (HR)", prefix: ["HR"] },
  { code: "HK", label: "Hong Kong (B-H, B-K, B-L)", prefix: ["B-H", "B-K", "B-L"] },
  { code: "IN", label: "India (VT)", prefix: ["VT"] },
  { code: "ID", label: "Indonezia (PK)", prefix: ["PK"] },
  { code: "JO", label: "Iordania (JY)", prefix: ["JY"] },
  { code: "IQ", label: "Irak (YI)", prefix: ["YI"] },
  { code: "IR", label: "Iran (EP)", prefix: ["EP"] },
  { code: "IE", label: "Irlanda (EI)", prefix: ["EI"] },
  { code: "IS", label: "Islanda (TF)", prefix: ["TF"] },
  { code: "IL", label: "Israel (4X)", prefix: ["4X"] },
  { code: "IT", label: "Italia (I)", prefix: ["I"] },
  { code: "JM", label: "Jamaica (6Y)", prefix: ["6Y"] },
  { code: "JP", label: "Japonia (JA)", prefix: ["JA"] },
  { code: "KZ", label: "Kazahstan (UP)", prefix: ["UP"] },
  { code: "KE", label: "Kenya (5Y)", prefix: ["5Y"] },
  { code: "KG", label: "KG (EX)", prefix: ["EX"] },
  { code: "KW", label: "Kuwait (9K)", prefix: ["9K"] },
  { code: "LA", label: "Laos (RDPL)", prefix: ["RDPL"] },
  { code: "LS", label: "Lesotho (7P)", prefix: ["7P"] },
  { code: "LV", label: "Letonia (YL)", prefix: ["YL"] },
  { code: "LB", label: "Liban (OD)", prefix: ["OD"] },
  { code: "LR", label: "Liberia (EL)", prefix: ["EL"] },
  { code: "LY", label: "Libia (5A)", prefix: ["5A"] },
  { code: "LI", label: "Liechtenstein (HB)", prefix: ["HB"] },
  { code: "LT", label: "Lituania (LY)", prefix: ["LY"] },
  { code: "LU", label: "Luxemburg (LX)", prefix: ["LX"] },
  { code: "MO", label: "Macao (B-M)", prefix: ["B-M"] },
  { code: "MK", label: "Macedonia de Nord (Z3)", prefix: ["Z3"] },
  { code: "MG", label: "Madagascar (5R)", prefix: ["5R"] },
  { code: "MY", label: "Malaysia (9M)", prefix: ["9M"] },
  { code: "MW", label: "Malawi (7Q)", prefix: ["7Q"] },
  { code: "MV", label: "Maldive (8Q)", prefix: ["8Q"] },
  { code: "ML", label: "Mali (TZ)", prefix: ["TZ"] },
  { code: "MT", label: "Malta (9H)", prefix: ["9H"] },
  { code: "IM", label: "Insula Man (M)", prefix: ["M"] },
  { code: "MA", label: "Maroc (CN)", prefix: ["CN"] },
  { code: "MH", label: "Insulele Marshall (V7)", prefix: ["V7"] },
  { code: "MU", label: "Mauritius (3B)", prefix: ["3B"] },
  { code: "MX", label: "Mexic (XA, XB, XC)", prefix: ["XA", "XB", "XC"] },
  { code: "MD", label: "Moldova (ER)", prefix: ["ER"] },
  { code: "MC", label: "Monaco (3A)", prefix: ["3A"] },
  { code: "MN", label: "Mongolia (JU)", prefix: ["JU"] },
  { code: "ME", label: "Muntenegru (4O)", prefix: ["4O"] },
  { code: "MZ", label: "Mozambic (C9)", prefix: ["C9"] },
  { code: "MM", label: "Myanmar (XY, XZ)", prefix: ["XY", "XZ"] },
  { code: "NA", label: "Namibia (V5)", prefix: ["V5"] },
  { code: "NP", label: "Nepal (9N)", prefix: ["9N"] },
  { code: "NI", label: "Nicaragua (YN)", prefix: ["YN"] },
  { code: "NE", label: "Niger (5U)", prefix: ["5U"] },
  { code: "NG", label: "Nigeria (5N)", prefix: ["5N"] },
  { code: "NO", label: "Norvegia (LN)", prefix: ["LN"] },
  { code: "NZ", label: "Noua Zeelandă (ZK)", prefix: ["ZK"] },
  { code: "OM", label: "Oman (A4O)", prefix: ["A4O"] },
  { code: "PK", label: "Pakistan (AP)", prefix: ["AP"] },
  { code: "PA", label: "Panama (HP)", prefix: ["HP"] },
  { code: "PG", label: "Papua Noua Guinee (P2)", prefix: ["P2"] },
  { code: "PY", label: "Paraguay (ZP)", prefix: ["ZP"] },
  { code: "PE", label: "Peru (OB)", prefix: ["OB"] },
  { code: "PL", label: "Polonia (SP, SN)", prefix: ["SP", "SN"] },
  { code: "PT", label: "Portugalia (CR, CS)", prefix: ["CR", "CS"] },
  { code: "QA", label: "Qatar (A7)", prefix: ["A7"] },
  { code: "GB", label: "Marea Britanie (G)", prefix: ["G"] },
  { code: "RU", label: "Rusia (RA, RF)", prefix: ["RA", "RF"] },
  { code: "RW", label: "Rwanda (9XR)", prefix: ["9XR"] },
  { code: "SM", label: "San Marino (T7)", prefix: ["T7"] },
  { code: "SN", label: "Senegal (6V, 6W)", prefix: ["6V", "6W"] },
  { code: "RS", label: "Serbia (YU)", prefix: ["YU"] },
  { code: "SC", label: "Seychelles (S7)", prefix: ["S7"] },
  { code: "SL", label: "Sierra Leone (9L)", prefix: ["9L"] },
  { code: "SG", label: "Singapore (9V)", prefix: ["9V"] },
  { code: "SY", label: "Siria (YK)", prefix: ["YK"] },
  { code: "SK", label: "Slovacia (OM)", prefix: ["OM"] },
  { code: "SI", label: "Slovenia (S5)", prefix: ["S5"] },
  { code: "SB", label: "Insulele Solomon (H4)", prefix: ["H4"] },
  { code: "SO", label: "Somalia (6O)", prefix: ["6O"] },
  { code: "ES", label: "Spania (EC)", prefix: ["EC"] },
  { code: "LK", label: "Sri Lanka (4R)", prefix: ["4R"] },
  { code: "US", label: "SUA (N)", prefix: ["N"] },
  { code: "SD", label: "Sudan (ST)", prefix: ["ST"] },
  { code: "SR", label: "Suriname (PZ)", prefix: ["PZ"] },
  { code: "SE", label: "Suedia (SE)", prefix: ["SE"] },
  { code: "TJ", label: "Tadjikistan (EY)", prefix: ["EY"] },
  { code: "TW", label: "Taiwan (B)", prefix: ["B"] },
  { code: "TZ", label: "Tanzania (5H)", prefix: ["5H"] },
  { code: "TH", label: "Thailanda (HS)", prefix: ["HS"] },
  { code: "TG", label: "Togo (5V)", prefix: ["5V"] },
  { code: "TO", label: "Tonga (A3)", prefix: ["A3"] },
  { code: "TT", label: "Trinidad și Tobago (9Y)", prefix: ["9Y"] },
  { code: "TN", label: "Tunisia (TS)", prefix: ["TS"] },
  { code: "TR", label: "Turcia (TC)", prefix: ["TC"] },
  { code: "TM", label: "Turkmenistan (EZ)", prefix: ["EZ"] },
  { code: "UA", label: "Ucraina (UR)", prefix: ["UR"] },
  { code: "UG", label: "Uganda (5X)", prefix: ["5X"] },
  { code: "HU", label: "Ungaria (HA)", prefix: ["HA"] },
  { code: "UY", label: "Uruguay (CX)", prefix: ["CX"] },
  { code: "UZ", label: "Uzbekistan (UK)", prefix: ["UK"] },
  { code: "VU", label: "Vanuatu (YJ)", prefix: ["YJ"] },
  { code: "VE", label: "Venezuela (YV)", prefix: ["YV"] },
  { code: "VN", label: "Vietnam (VN)", prefix: ["VN"] },
  { code: "YE", label: "Yemen (7O)", prefix: ["7O"] },
  { code: "ZM", label: "Zambia (9J)", prefix: ["9J"] },
  { code: "ZW", label: "Zimbabwe (Z)", prefix: ["Z"] },
  { code: "OTHER", label: "Altă țară (Alt prefix)", prefix: [] }
];

export const PROPELLER_TYPES = [
  { code: "FIXED", label: "Pas Fix (Fixed-Pitch)" },
  { code: "GROUND_ADJ", label: "Ajustabilă la sol (Ground-Adjustable)" },
  { code: "CONTROLLABLE", label: "Pas Controlabil (Controllable-Pitch)" },
  { code: "CONSTANT", label: "Viteză Constantă (Constant-Speed)" },
  { code: "FEATHERING", label: "Pliabilă / Feathering (Multi-engine)" },
  { code: "REVERSE", label: "Pas Reversibil (Reverse-Pitch)" }
];

export const PROPELLER_ROTATIONS = [
    "Clockwise",
    "Counter-Clockwise"
];

export const ENGINE_STATES = [
  { code: "ORIGINAL", label: "Original (În serviciu)" },
  { code: "NEW_REPLACED", label: "Înlocuit Nou" },
  { code: "SH_REPLACED", label: "Înlocuit Second-Hand" },
  { code: "OVERHAULED", label: "Revizuit Capital (0 SMOH)" },
  { code: "REPAIR_REQ", label: "Necesită Reparații" },
  { code: "RUN_OUT", label: "Resursă expirată (Past TBO)" }
];

export const ENGINE_COOLINGS = [
    { code: "AIR", label: "Aer" },
    { code: "LIQUID", label: "Lichid" }
];

export const LICENSE_TYPES = [
    "LAPL(A)",
    "PPL(A)",
    "CPL(A)",
    "ATPL(A)",
    "ULM (Aerostate/Avioane)",
    "SPL (Planor)",
    "BPL (Baloane)",
    "PPL(H) - Elicopter",
    "CPL(H) - Elicopter",
    "IR (Instrument Rating)",
    "ME (Multi Engine)",
    "FI (Flight Instructor)"
];

export const PART_STATES = [
  {
    code: "NEW",
    label: "Nouă",
  },
  {
    code: "NOS",
    label: "Nouă - Stoc Vechi",
  },
  {
    code: "OH",
    label: "Revizuită",
  },
  {
    code: "RP",
    label: "Reparată",
  },
  {
    code: "INSP",
    label: "Inspectată/Testată",
  },
  {
    code: "AR",
    label: "Utilizată - Bună",
  },
  {
    code: "UNS",
    label: "Nefuncțională",
  }
];

export const PART_CATEGORIES = [
  { code: "ENGINE_COMPLETE", label: "Motor Complet" },
  { code: "ENGINE_COMPONENTS", label: "Componente Motor" },
  { code: "PROPELLER", label: "Elice & Componente" },
  { code: "ROTOR_BLADES", label: "Pale Rotor" },
  { code: "TRANSMISSION", label: "Transmisie & Cutie Viteze (Heli)" },
  { code: "FUEL_SYSTEM", label: "Sistem Alimentare & Rezervoare" },
  { code: "EXHAUST_INTAKE", label: "Sisteme Admisie & Evacuare" },
  { code: "AVIONICS_INSTRUMENTS", label: "Avionică & Instrumente Bord" },
  { code: "COMM_NAV_EQUIP", label: "Echipamente Comunicare & Navigație" },
  { code: "ELECTRICAL_COMPONENTS", label: "Componente Electrice" },
  { code: "SENSORS_PROBES", label: "Senzori, Sonde & Antene" },
  { code: "LIGHTING_SYSTEMS", label: "Sisteme de Iluminat" },
  { code: "LANDING_GEAR", label: "Tren de Aterizare & Amortizoare" },
  { code: "BRAKES_WHEELS_TIRES", label: "Frâne, Roți & Anvelope" },
  { code: "CONTROL_SURFACES", label: "Suprafețe Control" },
  { code: "FUSELAGE_STRUCTURE", label: "Elemente Fuzelaj & Structură" },
  { code: "WINDOWS_CANOPIES", label: "Geamuri, Parbrize & Cupole" },
  { code: "INTERIOR_CABIN", label: "Interior & Confort Cabină" },
  { code: "SAFETY_SURVIVAL", label: "Echipamente Siguranță & Salvare" },
  { code: "HVAC_SYSTEMS", label: "Sisteme de Încălzire & Ventilație" },
  { code: "CONSUMABLES", label: "Consumabile" },
  { code: "HARDWARE_FASTENERS", label: "Hardware" },
  { code: "GROUND_EQUIPMENT", label: "Echipamente Sol & Scule Speciale" },
  { code: "OTHER", label: "Altele" }
];

export const EXPERIENCE_CATEGORIES = [
  { code: "SKYDIVING", label: "Parașutism" },
  { code: "PARAGLIDING", label: "Zbor cu parapanta/motoparapanta" },
  { code: "AEROBATIC_FLIGHT", label: "Zbor acrobatic" },
  { code: "SIGHTSEEING", label: "Zbor panoramic / agrement" },
  { code: "LIGHT_AIRCRAFT_FLIGHT", label: "Zbor cu avion ușor" },
  { code: "GLIDER_FLIGHTS", label: "Zbor cu planorul" },
  { code: "VINTAGE_AIRCRAFT_FLIGHT", label: "Zbor cu avion de epocă" },
  { code: "HELICOPTER_FLIGHT", label: "Zbor cu elicopterul" },
  { code: "HOT_AIR_BALOON", label: "Zbor cu balonul cu aer cald" },
  { code: "FLIGHT_LESSON", label: "Lecție de zbor (pilot pentru o zi)" },
  { code: "FLIGHT_SIMULATOR", label: "Simulator de zbor" }
];
